import { useACHPaymentInfo } from 'shared/modules/carrier-profile/data/CarrierProfileAPI';
import { ACHPaymentInfoDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';
import { ProfilePageLayout } from '../ProfilePageLayout';
import { ACHBankDetailsView } from './ACHBankDetailsView';
import { ACHDeleteConfirmDialog } from './ACHDeleteConfirmDialog';
import { ACHSuperPayBankDifferentBanner } from './ACHSuperPayBankDifferentBanner';
import { useACHDelete } from './useACHDelete';

export function ACHBankDetailsRestrictedView({
  paymentInfo,
}: {
  paymentInfo: ACHPaymentInfoDTO;
}) {
  const { isLoading } = useACHPaymentInfo();
  const { openConfirm, isDeleting, dialogProps } = useACHDelete();

  return (
    <>
      <ACHDeleteConfirmDialog {...dialogProps} />
      <ProfilePageLayout
        title="ACH Payment Info"
        isLoading={isLoading}
        actions={null}
      >
        <ACHBankDetailsView
          paymentInfo={paymentInfo}
          isDeleting={isDeleting}
          onDelete={openConfirm}
        />
        <ACHSuperPayBankDifferentBanner paymentInfo={paymentInfo} />
      </ProfilePageLayout>
    </>
  );
}
